import { Component, OnInit } from '@angular/core';
import { AppUtilService } from '../../../servicios/app.util.service';
import { AtributosService } from '../../../servicios/atributos.service';
import { HashKeyServices } from '../../../servicios/app.hashkey.services';

@Component({
  selector: 'app-footer-pag',
  templateUrl: './footer-pag.component.html',
  styleUrls: ['./footer-pag.component.css']
})
export class FooterPagComponent implements OnInit {
  fecha:any;
  empresa:any;
  constructor(
        private util:AppUtilService,
        private atrb:AtributosService,
        private hashkey:HashKeyServices
  ){
    this.fecha = this.atrb.FECHA.yyyy;
    this.empresa =  !localStorage.getItem('nmbrapp') ? '': this.hashkey.decrypt(localStorage.getItem('nmbrapp'));
  }

  ngOnInit(){}

}
